// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"122":"6b35e668","495":"bbdc7b07","528":"8044355f","627":"07f4a28f","644":"1d6ad931","795":"fb9bc3ed","952":"b0e8bfda"}[chunkId] + ".js";
};